import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _slicedToArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _has from "lodash/has";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es7.object.entries.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.promise.js";
import { SAMPLES_DELETE, SAMPLES_ERROR, SAMPLES_SAVING, SAMPLES_SAVED } from 'redux/actionTypes/samples';
import endUserMessages from 'utils/endUserMessages';
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
var cancelUploads = function cancelUploads(files) {
  Object.values(files).forEach(function (file) {
    var _file$upload;
    // eslint-disable-next-line no-unused-expressions
    (_file$upload = file.upload) === null || _file$upload === void 0 || (_file$upload = _file$upload.abortController) === null || _file$upload === void 0 || _file$upload.abort();
  });
};
var deleteSamples = function deleteSamples(sampleIds) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch, getState) {
      var _getState, samples, projectSamples, deleteSamplesPromise;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _getState = getState(), samples = _getState.samples;
            _context4.next = 3;
            return sampleIds.reduce(/*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(acc, sampleUuid) {
                var _samples$sampleUuid, experimentId, files;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _samples$sampleUuid = samples[sampleUuid], experimentId = _samples$sampleUuid.experimentId, files = _samples$sampleUuid.files;
                      if (!_has(acc, samples[sampleUuid].experimentId)) {
                        acc[samples[sampleUuid].experimentId] = [];
                      }
                      cancelUploads(files);
                      return _context.abrupt("return", _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, experimentId, [].concat(_toConsumableArray(acc[experimentId]), [sampleUuid]))));
                    case 4:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function (_x3, _x4) {
                return _ref2.apply(this, arguments);
              };
            }(), {});
          case 3:
            projectSamples = _context4.sent;
            dispatch({
              type: SAMPLES_SAVING,
              payload: {
                message: endUserMessages.DELETING_SAMPLE
              }
            });
            _context4.prev = 5;
            deleteSamplesPromise = Object.entries(projectSamples).map(/*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref3) {
                var _ref5, experimentId, samplesToDelete;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      _ref5 = _slicedToArray(_ref3, 2), experimentId = _ref5[0], samplesToDelete = _ref5[1];
                      _context3.next = 3;
                      return Promise.all(sampleIds.map(/*#__PURE__*/function () {
                        var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(sampleUuid) {
                          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                            while (1) switch (_context2.prev = _context2.next) {
                              case 0:
                                _context2.next = 2;
                                return fetchAPI("/v2/experiments/".concat(experimentId, "/samples/").concat(sampleUuid), {
                                  method: 'DELETE',
                                  headers: {
                                    'Content-Type': 'application/json'
                                  }
                                });
                              case 2:
                              case "end":
                                return _context2.stop();
                            }
                          }, _callee2);
                        }));
                        return function (_x6) {
                          return _ref6.apply(this, arguments);
                        };
                      }()));
                    case 3:
                      dispatch({
                        type: SAMPLES_DELETE,
                        payload: {
                          experimentId: experimentId,
                          sampleIds: samplesToDelete
                        }
                      });
                    case 4:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }));
              return function (_x5) {
                return _ref4.apply(this, arguments);
              };
            }());
            _context4.next = 9;
            return Promise.all(deleteSamplesPromise);
          case 9:
            dispatch({
              type: SAMPLES_SAVED
            });
            _context4.next = 16;
            break;
          case 12:
            _context4.prev = 12;
            _context4.t0 = _context4["catch"](5);
            handleError(_context4.t0, endUserMessages.ERROR_DELETING_SAMPLES);
            dispatch({
              type: SAMPLES_ERROR,
              payload: {
                error: endUserMessages.ERROR_DELETING_SAMPLES
              }
            });
          case 16:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[5, 12]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default deleteSamples;